var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menuContent
    ? _c(
        "b-nav",
        { staticClass: "navigation", class: _vm.menuDirection },
        [
          _vm._l(_vm.menuContent, function (list) {
            return [
              _vm._l(list, function (item, index) {
                return [
                  item.linkActive
                    ? [
                        item.columns && item.columns.length
                          ? [
                              _c(
                                "transition",
                                { key: index, attrs: { name: "slide-fade" } },
                                [
                                  _c(
                                    "b-nav-item-dropdown",
                                    {
                                      key: index,
                                      class: { "mega-menu": item.linkMegaMenu },
                                      attrs: {
                                        text: item.linkText,
                                        title: item.linkTitle,
                                        right: "",
                                      },
                                    },
                                    [
                                      _vm._l(
                                        item.columns,
                                        function (subItem, subIndex) {
                                          return subItem.linkActive
                                            ? [
                                                subItem.columns
                                                  ? [
                                                      _c(
                                                        "ul",
                                                        {
                                                          key: subIndex,
                                                          staticClass:
                                                            "menu-columns",
                                                          class: {
                                                            floated:
                                                              _vm.menuDirection ===
                                                              "horizontal",
                                                          },
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                subItem.linkText
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            subItem.columns,
                                                            function (
                                                              subSubItem,
                                                              subSubIndex
                                                            ) {
                                                              return subSubItem.linkActive
                                                                ? _c(
                                                                    "generic-menu-link",
                                                                    {
                                                                      key: subSubIndex,
                                                                      class:
                                                                        "btn-" +
                                                                        subSubItem.linkCallToAction,
                                                                      attrs: {
                                                                        href: subSubItem.linkUrl,
                                                                        target:
                                                                          subSubItem.linkTarget,
                                                                        title:
                                                                          subSubItem.linkTitle,
                                                                        "nav-type":
                                                                          "b-dropdown-item",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                      " +
                                                                          _vm._s(
                                                                            subSubItem.linkText
                                                                          ) +
                                                                          "\n                    "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "generic-menu-link",
                                                        {
                                                          key: subIndex,
                                                          class: [
                                                            "single-link btn-" +
                                                              subItem.linkCallToAction,
                                                          ],
                                                          attrs: {
                                                            href: subItem.linkUrl,
                                                            target:
                                                              subItem.linkTarget,
                                                            title:
                                                              subItem.linkTitle,
                                                            "nav-type":
                                                              "b-dropdown-item",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                subItem.linkText
                                                              ) +
                                                              "\n\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ]
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              _c(
                                "generic-menu-link",
                                {
                                  key: index,
                                  class: "btn-" + item.linkCallToAction,
                                  attrs: {
                                    href: item.linkUrl,
                                    target: item.linkTarget,
                                    title: item.linkTitle,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.linkText) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                      ]
                    : _vm._e(),
                ]
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }